import "./breadcrumbs.scss";

import { Link } from "react-router-dom";
import React from "react";

export default function Breadcrumbs({ breadcrumbs, className }) {
  return (
    <div className={`breadcrumbs lato-regular ${className}`}>
      {breadcrumbs?.map((breadcrumb, index) => (
        <span key={index} className={index === breadcrumbs?.length - 1 ? 'text-text_dark_2' : 'text-text_dark_3'}>
          {index > 0 && <span className="separator">/</span>}
          {breadcrumb.link ? (
            <Link to={breadcrumb.link}>{breadcrumb.label}</Link>
          ) : (
            <span className="cursor-default">{breadcrumb.label}</span>
          )}
        </span>
      ))}
    </div>
  );
}
